import { GET_WORD_VAULT, GET_CATEGORIES, CREATE_WORD, GET_WORD_DETAILS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getCategories = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/categories`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch categories.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_CATEGORIES,
        payload: data
      })
    }
  }
}

export const getWordVault = (unitID) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch word vault.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_WORD_VAULT,
        payload: data
      })
    }
  }
}

export const getSearchResults = (unitID, searchText, fireFound, fireNotFound) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { searchText }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(
      window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words/search`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch search results.')
    } else {
      const { data } = await response.json()

      if (data?.length) {
        const [wordInfo] = data
        fireFound(wordInfo)
      } else {
        fireNotFound()
      }
    }
  }
}

export const getWordDetails = (unitID, wordID) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(
      window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words/${wordID}`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch search results.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_WORD_DETAILS,
        payload: data
      })
    }
  }
}

export const createNewWord = (unitID, info, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...info, supervisorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
      return false
    } else {
      fireSuccess()
      dispatch({
        type: CREATE_WORD,
        payload: { ...body }
      })
      return true
    }
  }
}

export const updateWord = (info, wordID, unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...info, supervisorID }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words/${wordID}`, options))

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const deleteWord = (wordID, unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/unit/${unitID}/words/${wordID}`, options))

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}
